<template>
  <div class="container">
    <form @submit.prevent="addTodo(todo)" class="newTodo">
      <button class="btn btn-success newButton" type="submit"><i class="fa fa-plus"></i></button>
      <span class="todoInputSpan"><input class="todoInput" v-model="todo"></span>
    </form>

      <transition-group name="todos" tag="p" appear>
        <ul v-for="(todo, idx) in todos" :key="todos[idx].id" style=" list-style-type:none; margin-left: -39px;">
          <li class="todoItem" >
            <div style="height: 100%">
              <a @click.prevent="doneTodo(todo.id)" class="todoKnoppen" v-if="!todo.done" href="#" style="margin-left: 9px; margin-right: 6px; float: right; color: dimgrey" :class="{ inactive:todo.done }"><i class="fa fa-check"></i></a> 
              </div>
            <a @click.prevent="deleteTodo(todo.id)" class="todoKnoppen" v-if="todo.done" href="#" style="float: right; color: dimgrey; margin-left: 10px; margin-right: 10px;"><i class="fa fa-remove"></i></a>
            <span class="todoInputSpan todoItemText" style="border-right: 1px dotted lightgrey;"><span :class="{crossed: todos[idx].done}">{{ todo.todo }}</span></span>
          </li>         
        </ul>
      </transition-group>
  </div>
</template>

<script>
import { db } from './main'

export default {
  data () {
    return {
      todos: [{
        done: false
      }],
      todo: '',
    }
  },
  firestore() {
    return {
      todos: db.collection('todos').orderBy('createdAt')
    }
  },
  methods: {
    addTodo(todo) {
      const createdAt = new Date();
      const done = false;
      const crossed = false;
      db.collection('todos').add({todo, done, createdAt});
      this.todo = '';
    },
    deleteTodo(id) {
      db.collection('todos').doc(id).delete();
    },
    doneTodo(id) {
      var docRef = db.collection("todos").doc(id);
      docRef.get().then(function(doc) {
        if (doc.exists) {
          if(doc.data().done==false){
            db.collection("todos").doc(id).update({
              done:true
            })            
          } else {
            db.collection("todos").doc(id).update({
              done:false
            })               
          }
        } else {
          console.log("no such document");
        }
      }).catch(function(error){
         console.log("error getting document")
      })

    }
  }
}
</script>

<style>
html{
  height: 100%;
}

.container{
  width: 50%
} 

.todos-leave-active, .todos-enter-active{
  transition: all 1s ease;
}
.todos-enter {
  opacity: 0;
  transform: translateY(-30px);
}
.todos-leave-to{
  opacity: 0;
  transform: translateY(30px);
}

.todoItem {
  background-color: rgba(255, 255, 255, 0.6);
  margin-bottom: -12px;
  vertical-align: middle;
  padding-left: 15px;
  border-radius: 5px;
  font-size: 1.5em;
  padding: auto;
}
.todoInputSpan{
  display: block;
  overflow: hidden;
}
.todoItemText{
  min-height: 40px;
}
.todoInput{
  width: 100%; 
  height: 38px; 
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.6);
  font-size: 1.3em;
  border-style: none;
  padding-left: 15px;
}
.newTodo{
  padding-bottom: 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px; 
  padding-top: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  overflow: hidden;
}

.newButton{
  float: right;
  font-weight: bold;
  height: 38px;
  overflow: hidden;
}

input[type=checkbox]{
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  margin-right: 20px;
}

.crossed {
  text-decoration: line-through;
  opacity: 0.4;
}

.inactive {
  opacity: 0.5;
  transition: all 1s;
}

a{
  color: black;
}

a:hover {
  text-decoration: none;
  color: black;
}

@media only screen and (max-width: 1045px) {
  .container{
    width: 100%
  }
  .todoInputSpan{
    overflow: scroll;
  }
  .todoItem {
    font-size: 1.1em;
  }
  .todoItemText{
    padding-top: 8px;
  }
  .todoKnoppen{
    margin-top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/todos.vue